module.exports = __webpack_public_path__ + "static/media/sapo.c82d859c.webp";